import { Typography } from "@mui/material";
import UploadFileIcon from "assets/images/UploadFile.png";
import { DragEvent } from "react";
import { useTranslation } from "react-i18next";

interface IInitialViewProps {
  dropHandler(event: DragEvent<HTMLDivElement>): void;
  uploadHandler(): void;
}
export function InitialView({ dropHandler, uploadHandler }: IInitialViewProps) {
  const { t } = useTranslation();
  const dragOverHandler = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };
  return (
    <Typography
      component="div"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%",
      }}
      onDrop={dropHandler}
      onDragOver={dragOverHandler}
    >
      <img
        src={UploadFileIcon}
        style={{ width: "48px" }}
        alt="Upload Class list"
      />
      <span style={{ padding: "10px" }}>{t("Drag classes file")}</span>
      <span>{t("Or")}</span>
      <span
        onClick={uploadHandler}
        style={{
          color: "rgb(60 180 229)",
          textDecoration: "underline",
          cursor: "pointer",
        }}
      >
        {t("Choose a file from your device")}
      </span>
    </Typography>
  );
}
